var _jsxFileName = "/opt/atlassian/pipelines/agent/build/src/components/utility/Header/index.tsx";
import React from 'react';
import { Stack, Text } from '@adc/parallax-component-library';
const Header = ({
  title,
  subtitle,
  testID,
  visible = true,
  ...rest
}) => {
  if (!visible) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Stack, Object.assign({
    paddingHorizontal: "$4"
  }, rest, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 18,
      columnNumber: 5
    }
  }), /*#__PURE__*/React.createElement(Text, {
    testID: `${testID}-title`,
    textAlign: "auto",
    fontSize: "$h1.strong",
    fontWeight: "$h1.strong",
    marginTop: "$4",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 19,
      columnNumber: 7
    }
  }, title), /*#__PURE__*/React.createElement(Text, {
    testID: `${testID}-subtitle`,
    textAlign: "auto",
    fontSize: "$bodyBase.default",
    fontWeight: "$bodyBase.default",
    color: "$text.100",
    marginTop: "$4",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 28,
      columnNumber: 7
    }
  }, subtitle));
};
export { Header };